import { Helmet } from "react-helmet-async";
import { SITE } from "../data/site";

export default function Seo({
  title,
  description,
  path = "/",
  image = "/images/start-image-1.jpg",
  type = "website",
  jsonLd,
}) {
  const url = `${SITE.url}${path}`;
  const fullTitle = title.includes("CCS")
    ? title
    : `${title} | ${SITE.name}`;
  const img = image.startsWith("http") ? image : `${SITE.url}${image}`;

  return (
    <Helmet>
      <html lang="de" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}

export function localBusinessJsonLd() {
  const [hq, office] = SITE.addresses;
  return {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    name: SITE.name,
    url: SITE.url,
    image: `${SITE.url}/logo.avif`,
    telephone: SITE.phoneTel,
    email: SITE.email,
    slogan: SITE.tagline,
    priceRange: "€€",
    areaServed: SITE.area.map((name) => ({ "@type": "City", name })),
    address: {
      "@type": "PostalAddress",
      streetAddress: hq.street,
      postalCode: hq.zip,
      addressLocality: hq.city,
      addressCountry: "DE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: SITE.geo.lat,
      longitude: SITE.geo.lng,
    },
    department: {
      "@type": "PostalAddress",
      streetAddress: office.street,
      postalCode: office.zip,
      addressLocality: office.city,
      addressCountry: "DE",
    },
  };
}
